import { render } from "./Scroll.vue?vue&type=template&id=2e6e0f1b&scoped=true"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"

import "./Scroll.vue?vue&type=style&index=0&id=2e6e0f1b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6e0f1b"]])

export default __exports__